import React from 'react';
import { Route, useRouteMatch } from "react-router-dom";
import ScholarshipInvetoryRouter from "./ScholarshipInventory/ScholarshipInvetoryRouter";
import FieldOfStudyRouter from "./FieldOfStudy/FieldOfStudyRouter";

const ScholarshipFeaturePage = () => {
    let { path } = useRouteMatch();

    return (
        <div>
            <Route path={`${path}/scholarships`}>
                <ScholarshipInvetoryRouter />
            </Route>
            <Route path={`${path}/field-of-study`}>
                <FieldOfStudyRouter />
            </Route>
        </div>
    );
};

export default ScholarshipFeaturePage;
